import { useCallback } from 'react';
import { useIframeMessageContext } from '../../IframeMessageContext';
import { registerIframeMessageHook } from './IframeRegistration';
const MESSAGE_TYPE = 'edit-site';
export function useSendSite() {
    const { postMessage } = useIframeMessageContext();
    const sendSite = useCallback((site) => {
        postMessage(MESSAGE_TYPE, site);
    }, [postMessage]);
    return { sendSite };
}
const handleMessage = (context, message) => {
    if (message.body) {
        const { setSite } = context;
        setSite(message.body, { shouldSendIframe: false });
    }
};
registerIframeMessageHook(MESSAGE_TYPE, useSendSite, handleMessage);
//# sourceMappingURL=useSendSite.js.map